<template>

  <div class="text-center" v-show="visible">
    <el-tooltip placement="top" content="Pick up parked call">
      <el-button class="parked-call" v-if="!navCollapsed" @click="pickUpCall">
        <div class="flex" style="width: 100%;">
          <div class="contact-avatar">
            <el-tooltip content="Pick Up" placement="top">
              <v-svg sprite="call-park" class="voxo-orange" />
            </el-tooltip>
          </div>
          <div class="caller-id flex align-center">
            <div>
              <div class="text-left">
                <strong>{{ renderedCallerName }}</strong>
              </div>
              <div class="text-muted text-left caller-id-number">
                {{ numberFormatter(callerNumber)}}
              </div>
            </div>
          </div>
          <span class="call-badge flex align-center">
            <el-tooltip effect="dark" content="Parked" placement="right">
              <el-badge :value="convertTime(durationCount)" class="item" type="primary"></el-badge>
            </el-tooltip>
          </span>
        </div>
      </el-button>
    </el-tooltip>

    <el-popover
      popper-class="connected-call-pop"
      trigger="click"
      placement="right"
      width="250"
      v-if="navCollapsed">
      <el-card class="connected-call card-base card-shadow--medium">
        <div slot="header" class="clearfix">
          <div class="avatar-group">
            <div class="caller-id">
              <div>
                <div class="text-left">
                  <strong>{{ callerName }}</strong>
                </div>
                <div class="text-muted caller-id-number">
                  {{ numberFormatter(callerNumber)}}
                </div>
              </div>
            </div>
            <span class="call-badge">
              <el-tooltip effect="dark" content="Parked" placement="right">
                <el-badge :value="convertTime(durationCount)" class="item" type="primary"></el-badge>
              </el-tooltip>
            </span>
          </div>
        </div>
      </el-card>
      <el-button slot="reference" class="keypad-btn nav-call-button">
        <v-svg sprite="call-park"/>
      </el-button>
    </el-popover>
  </div>

</template>

<script>

import {globalEventBus} from "@/globalEventBus";
import feathersClient from "@/feathers/feathers-client";
import {mapGetters} from "vuex";
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: 'MyParkedCall',
  props: {
    callerNumber: {required: true},
    callerName: {required: true},
    parkingLot: {required: true},
    parkingSpace: {required: true}
  },
  data(){
    return {
      durationCount: 0,
      durationCounter: null,
      renderedCallerName: '',
      visible: true,
    }
  },
  computed: {
    ...mapGetters('phonebook-entries', {loadPersonalDirectory: 'find'}),

    navCollapsed(){
      return this.$store.state.collapseNav;
    },
    user(){
      return this.$store.state.auth.user;
    },
    softphoneEnabled(){
      return this.$store.state.softphoneEnabled;
    }
  },
  methods: {
    convertTime(time) {
      if(time < 60) {return time + 's'}
      const hours = Math.floor(time / 3600);
      const remainderSeconds = time % 3600;
      const minutes = Math.floor(remainderSeconds / 60);
      const seconds = Math.round(remainderSeconds % 60);
      if (hours > 0) {return hours + 'hr ' + minutes + 'm';}
      if (minutes > 0) {return minutes + 'm ' + seconds + 's';}
      return 0;
    },
    updateDuration(){
      this.durationCount++;
    },
    numberFormatter(number) {
      return number ? phoneNumberFormatter(number) : number;
    },

    async findCallerName(){

      let callerName = this.callerName;

      const bizContact = await feathersClient.service('extensions').find({
        query: {
          tenantId: this.user.myExtension.tenantId,
          number: this.callerNumber
        }
      });

      if(bizContact.length){
        callerName = bizContact[0].name;
      } else{
        const personalContact = this.loadPersonalDirectory({
          query: {
            "PHONE1": this.callerNumber
          }
        }).data;

        if(personalContact.length){
          callerName = personalContact[0].NAME;
        }
      }
      this.renderedCallerName = callerName.length ? callerName : 'Unknown';
    },

    pickUpCall(){

      //picking up park is outbound call, so only allow if softphone enabled
      if(this.softphoneEnabled){
        const startAudio = document.getElementById('call-accepted').querySelector('audio');
        startAudio.play();
        this.dismissWidget();
        this.clearPushNotify();
        globalEventBus.$emit('dialSoftphone', this.parkingSpace);
        return;
      }

      this.$notify({
        title: 'Warning',
        message: 'Enable softphone to pick up parked call.',
        type: 'warning'
      });

    },

    dismissWidget(){
      this.visible = false;
    },

    async clearPushNotify(){
      try{
        const reg = await navigator.serviceWorker.getRegistration();
        const notifications = await reg.getNotifications({
          includeTriggered: true
        });
        notifications.forEach((notification) => {
          notification.close();
        });
      } catch (e){
        console.log(e);
      }
    },
  },
  mounted(){
    this.durationCounter = setInterval(this.updateDuration, 1000);
    this.findCallerName();
  },
  beforeDestroy() {
    clearInterval(this.durationCounter);
  }
}

</script>
